import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "service",
  class: "service-wrap pb-100"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "service-card style2" }
const _hoisted_4 = { class: "service-icon" }
const _hoisted_5 = { class: "service-info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Slide = _resolveComponent("Slide")!
  const _component_Navigation = _resolveComponent("Navigation")!
  const _component_Carousel = _resolveComponent("Carousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "row" }, [
        _createElementVNode("div", { class: "col-xl-6 offset-xl-3 col-lg-8 offset-lg-2" }, [
          _createElementVNode("div", { class: "section-title style1 text-center mb-40" }, [
            _createElementVNode("span", null, "What's Happening"),
            _createElementVNode("h2", null, "We're Providing Best Services To Our Customers")
          ])
        ])
      ], -1)),
      _createVNode(_component_Carousel, {
        autoplay: 5000,
        "wrap-around": true,
        breakpoints: _ctx.breakpoints,
        "pause-autoplay-on-hover": "",
        class: "service-slider-one"
      }, {
        addons: _withCtx(() => [
          _createVNode(_component_Navigation)
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.services, (service) => {
            return (_openBlock(), _createBlock(_component_Slide, {
              key: service.id
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("i", {
                      class: _normalizeClass(service.icon)
                    }, null, 2)
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("h3", null, [
                      _createVNode(_component_router_link, { to: "/service-details" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(service.title), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _createElementVNode("p", null, _toDisplayString(service.shotDesc), 1)
                  ])
                ])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["breakpoints"])
    ])
  ]))
}